import Datepicker from './Datepicker'

export default Datepicker



// WEBPACK FOOTER //
// ./src/components/datepicker/index.js